<!-- 更改储值或次数VIP的金额/次数接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","ticketNo":"001","operator":"operator","operateTime":"2017-03-28 00:00:00","addValue":"1","serialNumber":"11111"},
            responseCode: 	{
                "data": {
                    "restValue":"1111"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台更改储值或次数VIP的金额/次数",
                t_url: this.commonUrls.test+"changeVipValue",
                p_url: this.commonUrls.prod+"changeVipValue",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'ticketNo', info2: '是', info3: 'String', info4: '月卡唯一编号' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'addValue', info2: '是', info3: 'Decimal', info4: '添加值' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyyMMddHHmmss' },
                        { info1: 'serialNumber', info2: '是', info3: 'String', info4: '流水号费流水防重，唯一续费流水号,同一次续费流水号唯一，用于多次下发同一续费流水防重' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'restValue', info2: '是', info3: 'Decimal', info4: '变更后的剩余值' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/changeVipValue.vue